<template>
  <div class="container content-padding box-bg">
    <div class="container-main">
      <div class="container-main-header">
        <div class="search-box" style="padding-bottom: 0px">
          <div class="index-top-box">
            <font class="index-search-font" style="font-size: 16px"
              >智能控制</font
            >
            <span class="index-top-title" style="font-size: 16px"
              >/添加触发条件</span
            >
          </div>
          <div style="height: 16px"></div>
          <div class="top-opption" style="bottom: 19px">
            <el-button
              type="primary"
              class="left"
              @click="addbox()"
              v-if="tableData.length > 0"
              >+添加触发条件</el-button
            >
            <el-button type="primary" class="step-positon" @click="goTo()"
              >上一步</el-button
            >
            <el-button type="primary" class="step-positon" @click="goTo2()"
              >下一步</el-button
            >
          </div>
        </div>
      </div>

      <div class="equipmentlist box-padding-mide">
        <div class="mudel-left-box">
          <div class="container-content-head">
            <span class="title">添加触发条件</span>
          </div>
          <div class="container-content tablecontent" style="height: 800px">
            <div class="equipmentcenter">
              <el-steps :active="1" align-center>
                <el-step title="添加控制"></el-step>
                <el-step title="添加触发条件"></el-step>
                <el-step title="添加执行动作"></el-step>
              </el-steps>
            </div>
            <div class="equipmentcenter-step-box"></div>
            <div
              class="equipmentcenter-opption-box inside-box"
              v-if="tableData.length <= 0"
              style="width: 800px; border: none !important"
            >
              <el-form
                ref="ruleForm"
                :rules="rules"
                :model="form"
                label-width="100px"
              >
                <el-form-item label="开始时间：">
                  <el-time-picker
                    v-model="form.startTime"
                    :picker-options="{
                      selectableRange: '00:00:00 - ' + form.endTime,
                    }"
                    placeholder="开始时间"
                    :clearable="false"
                    value-format="HH:mm:ss"
                  ></el-time-picker>
                  <span class="zt-span" style="margin-left: 86px !important"
                    >结束时间：</span
                  >
                  <el-time-picker
                    v-model="form.endTime"
                    :picker-options="{
                      selectableRange: form.startTime + ' - 23:59:59',
                    }"
                    placeholder="结束时间"
                    :clearable="false"
                    value-format="HH:mm:ss"
                  ></el-time-picker>
                </el-form-item>
                <el-form-item label="定时类型：">
                  <el-select
                    v-model="form.timeType"
                    placeholder="请选择定时类型"
                  >
                    <el-option label="重复" value="0"></el-option>
                    <el-option label="一次" value="1"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="定时时间：">
                  <el-select
                    v-if="form.timeType == 0"
                    v-model="form.executionWeek"
                    multiple
                    placeholder="请选择定时时间"
                  >
                    <el-option
                      v-for="item in options"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                  <el-date-picker
                    v-if="form.timeType == 1"
                    v-model="form.executionDate"
                    style="width: 596px"
                    value-format="yyyy-MM-dd"
                    type="date"
                    placeholder="请选择定时时间"
                  ></el-date-picker>
                </el-form-item>
                <el-form-item style="text-align: center; margin-top: 20px">
                  <el-button
                    type="primary"
                    style="width: 120px"
                    @click="addDeviceAttribute()"
                    >保存</el-button
                  >
                </el-form-item>
              </el-form>
            </div>
            <div
              class="container-content tablecontent"
              v-if="tableData.length > 0"
            >
              <el-table
                class="data-table"
                style="width: 100%"
                :data="tableData"
                align="center"
                :header-cell-style="{ background: '#F6F6F6' }"
                v-loading="isloading"
              >
                <el-table-column label="开始时间">
                  <template slot-scope="scope">
                    <p>{{ scope.row.startTime }}</p>
                  </template>
                </el-table-column>
                <el-table-column label="结束时间">
                  <template slot-scope="scope">
                    <p>{{ scope.row.endTime }}</p>
                  </template>
                </el-table-column>
                <el-table-column label="定时类型">
                  <template slot-scope="scope">
                    <p>{{ scope.row.timeType | timeType }}</p>
                  </template>
                </el-table-column>
                <el-table-column label="定时时间">
                  <template slot-scope="scope">
                    <p v-if="scope.row.timeType == 0">
                      {{ scope.row.executionWeek | executionWeek }}
                    </p>
                    <p v-if="scope.row.timeType == 1">
                      {{ scope.row.executionDate }}
                    </p>
                  </template>
                </el-table-column>
                <el-table-column label="操作" width="150px">
                  <template slot-scope="scope">
                    <a class="td-opption" @click="updatabox(scope.row.id, '2')"
                      >编辑</a
                    >
                    <a class="td-opption del" @click="del(scope.row.id)"
                      >删除</a
                    >
                  </template>
                </el-table-column>
              </el-table>
            </div>
            <el-dialog
              :title="title"
              :visible.sync="dialogVisible"
              width="880px"
              :before-close="handleClose"
            >
              <div class="equipmentcenter-opption-box">
                <el-form
                  ref="ruleForm"
                  :rules="rules"
                  :model="form"
                  label-width="100px"
                >
                  <el-form-item label="开始时间：">
                    <el-time-picker
                      class="w232"
                      v-model="form.startTime"
                      :picker-options="{
                        selectableRange: '00:00:00 - ' + form.endTime,
                      }"
                      placeholder="开始时间"
                      :clearable="false"
                      value-format="HH:mm:ss"
                    ></el-time-picker>
                    <span class="zt-span">结束时间：</span>
                    <el-time-picker
                      class="w232"
                      v-model="form.endTime"
                      :picker-options="{
                        selectableRange: form.startTime + ' - 23:59:59',
                      }"
                      placeholder="结束时间"
                      :clearable="false"
                      value-format="HH:mm:ss"
                    ></el-time-picker>
                  </el-form-item>

                  <el-form-item label="定时类型：">
                    <el-select
                      v-model="form.timeType"
                      placeholder="请选择定时类型"
                    >
                      <el-option label="重复" value="0"></el-option>
                      <el-option label="一次" value="1"></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="定时时间：">
                    <el-select
                      v-if="form.timeType == 0"
                      v-model="form.executionWeek"
                      multiple
                      placeholder="请选择定时时间"
                    >
                      <el-option
                        v-for="item in options"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      ></el-option>
                    </el-select>
                    <el-date-picker
                      v-if="form.timeType == 1"
                      v-model="form.executionDate"
                      value-format="yyyy-MM-dd"
                      type="date"
                      placeholder="请选择定时时间"
                      style="width: 632px"
                    ></el-date-picker>
                  </el-form-item>

                  <el-form-item style="margin-top: 30px">
                    <el-button
                      type="info"
                      style="
                        width: 120px;
                        margin-right: 10px;
                        margin-left: 110px;
                      "
                      @click="handleClose()"
                      >取消</el-button
                    >
                    <el-button
                      type="primary"
                      style="width: 120px; margin-right: 75px"
                      @click="addDeviceAttribute()"
                      >保存</el-button
                    >
                  </el-form-item>
                </el-form>
              </div>
            </el-dialog>
          </div>
        </div>
        <div class="mudel-right-box">
          <div class="mudel-right-box-box" style="height: 860px">
            <div
              class="container-content-head"
              style="border-bottom: 1px solid #f4f8f9"
            >
              <i class="top-nav"></i>
              <span class="title">词条注释</span>
            </div>
            <div class="mudel-expalin">
              <p>
                当第一步设置的是"定时"控制类型时，当前步骤配置的是设备主动触发动作时需要的时间节点范围，当第一步设置的是"自动"控制类型时，当前步骤配置的是设备主动触发动作时属性所达到的范围值
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "equipmentcenter",
  components: {},
  data() {
    return {
      dialogVisible: false,
      title: "添加设备属性",
      isupdatestate: "1",
      updatestate: "1", //1：添加 2：编辑
      options: [
        {
          value: "1",
          label: "周一",
        },
        {
          value: "2",
          label: "周二",
        },
        {
          value: "3",
          label: "周三",
        },
        {
          value: "4",
          label: "周四",
        },
        {
          value: "5",
          label: "周五",
        },
        {
          value: "6",
          label: "周六",
        },
        {
          value: "7",
          label: "周日",
        },
      ],
      form: {
        id: undefined,
        startTime: "00:00:00",
        endTime: "23:59:59",
        linkageControlId: "",
        executionWeek: [],
        executionDate: "",
        timeType: "0",
        step: "3",
      },
      tableData: [],
      allcmd: [],
      allalert: [],
      rules: {
        startTime: [
          {
            required: true,
            message: "请输入开始时间",
            trigger: "blur",
          },
        ],

        timeType: [
          {
            required: true,
            message: "请选择定时类型",
            trigger: "blur",
          },
        ],
      },
    };
  },
  methods: {
    goTo() {
      this.$router.push({
        name: `Linkagecenter1`,
      });
    },
    goTo2() {
      this.$router.push({
        name: `Linkagecenter3`,
      });
    },
    addDeviceAttribute() {
      if (this.form.timeType == 0) {
        // 0重复
        if (this.form.executionWeek.length == 0) {
          this.$toaster.error("请选择定时时间");
          return false;
        }
        this.form.executionWeek = this.form.executionWeek.toString();
        this.form.executionDate = "";
      } else {
        // 1一次
        if (!this.form.executionDate) {
          this.$toaster.error("请选择定时时间");
          return false;
        }
        this.form.executionWeek = "";
      }
      if (this.updatestate == 1) {
        // 添加
        this.form.id = undefined;
        this.$refs["ruleForm"].validate((valid) => {
          if (valid) {
            this.$api.device.saveLinkageControlTime(this.form).then((res) => {
              if (res.code == 200) {
                this.form.id = undefined;
                this.$toaster.ok("保存成功");
                this.getDeviceAttributeList();
                this.handleClose();
              } else {
                this.$toaster.error(res.msg);
              }
            });
          } else {
            this.$toaster.error("保存失败，请先完善信息");
            this.isSaveDraft = false;
            return false;
          }
        });
      } else if (this.updatestate == 2) {
        // 编辑
        this.$refs["ruleForm"].validate((valid) => {
          if (valid) {
            this.$api.device.saveLinkageControlTime(this.form).then((res) => {
              if (res.code == 200) {
                this.form.id = res.data;
                this.$toaster.ok("编辑成功");
                this.getDeviceAttributeList();
                this.handleClose();
              } else {
                this.$toaster.error(res.msg);
              }
            });
          } else {
            this.$toaster.error("编辑失败，请先完善信息");
            this.isSaveDraft = false;
            return false;
          }
        });
      }
    },
    addbox() {
      this.updatestate = 1;
      this.title = "添加触发条件";
      this.form = {
        id: undefined,
        startTime: "00:00:00", //开始时间
        endTime: "23:59:59",
        linkageControlId: sessionStorage.getItem("projectEditId"),
        executionWeek: [],
        executionDate: "",
        timeType: "0",
        step: "3",
      };
      this.dialogVisible = true;
    },
    updatabox(id) {
      this.updatestate = 2;
      this.title = "编辑触发条件";
      this.form.id = id;
      this.dialogVisible = true;
      this.getDeviceAttribute(id);
    },
    handleClose() {
      this.$refs["ruleForm"].resetFields();
      this.dialogVisible = false;
    },
    del(id) {
      this.$confirm("是否确定删除？", "", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "error",
      }).then(() => {
        this.$api.device
          .delfun("pc/linkageControl/deleteLinkageControlTime", id)
          .then((res) => {
            if (res.code == 200) {
              this.getDeviceAttributeList();
              this.$toaster.ok(res.msg);
            } else {
              this.$toaster.error(res.msg);
            }
          });
      });
    },
    getDeviceAttribute(id) {
      //根据ID获取设备属性详情
      this.isloading = true;
      //this.$refs["form"].resetFields();
      this.$api.device.getTimeById(id).then((res) => {
        if (res.code == 200) {
          this.form = res.data;
          this.isloading = false;
          this.form.timeType = this.form.timeType.toString();
          this.form.executionWeek = this.form.executionWeek.split(",");
          this.form.executionDate = this.$$utils.zhDate(
            this.form.executionDate
          );
        }
      });
    },
    getDeviceAttributeList() {
      //获取属性列表
      var projectEditId = sessionStorage.getItem("projectEditId"); // 获取修改时的项目id
      if (projectEditId == undefined || projectEditId == null) {
        this.form.linkageControlId = "";
      } else {
        this.isloading = true;
        this.form.linkageControlId = projectEditId;
        this.$api.device
          .getTimeListByControlId(this.form.linkageControlId)
          .then((res) => {
            if (res.code == 200) {
              if (res.data.length > 0) {
                this.isupdatestate = "2";
              } else {
                this.isupdatestate = "1";
              }
              this.tableData = res.data;
              this.isloading = false;
            }
          });
      }
    },
    getstate() {
      var projectEditId = sessionStorage.getItem("projectEditId"); // 获取修改时的项目id
      this.tztype = sessionStorage.getItem("tztype");
      this.form.linkageControlId = projectEditId;
    },
  },
  mounted() {
    this.getstate();
    this.getDeviceAttributeList();
  },
  activated: {},
  watch: {},
};
</script>
<style>
.box-padding {
  padding: 20px;
}
.box-bg {
  background: #fff;
}
</style>